import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class WCCategoriesQueryService {

    public GET_CATEGORIES: any;
    public SEARCH_CATEGORIES: any;
    public GET_LAST_CATEGORY_ID:any;
    public CREATE_WC_CATEGORY:any;

    constructor(public apollo: Apollo) {

        this.GET_CATEGORIES =
            gql`
            query getCategories{                           
                allWccategories  {
                #   edges {
                    nodes {
                        category
                        categoryid
                        wcsubcategoriesByCategoryid  {
                            # edges {
                                nodes {
                                subcategory
                                categoryid
                                subid
                                }
                            # }
                        }
                    }
                #   }
                }
              }
        `;
        //insensitive check or between incase primary category as two word (inculdes) without 
        this.SEARCH_CATEGORIES =
            gql`
            query searchPrimaryCategory($keyword:String!){
                allWccategories (filter: {category: {startsWithInsensitive: $keyword}} ) {
                      nodes {
                            categoryid
                            category
                     }
                }
            }          
        `;

        this.GET_LAST_CATEGORY_ID=gql`
        query getLastSubcategory{
            allWccategories (last:1) {
                 edges {
                    node {
                        categoryid
                    }
                 }
            }
        }
    `;
    this.CREATE_WC_CATEGORY=gql`
    mutation createWcCategory($input:CreateWccategoryInput!){
        createWccategory(input:$input){
                wccategoryEdge  {
                        node{
                            category
                            categoryid
                            createdat
                            }
                }  
        }
    }  
    `;
    }

    /** Get all wc categories - Walk talk & Walk Call */
    GET_WC_CATEGORIES() {
        return this.apollo
            .watchQuery({
                query: this.GET_CATEGORIES
                ,
                fetchPolicy: 'network-only'
            });
    }

      /** Get all wc categories - Walk talk & Walk Call */
      SEARCH_WC_CATEGORIES(searchCategory) {
        return this.apollo
            .watchQuery({
                query: this.SEARCH_CATEGORIES,
                variables:
                {
                    "keyword":searchCategory
                },
                fetchPolicy: 'network-only'
            });
    }

    //get Last category Id
    GET_LAST_WC_CATEGORY_ID(){
        return this.apollo
            .watchQuery({
                query: this.GET_LAST_CATEGORY_ID
                ,
                fetchPolicy: 'network-only'
            });
    }

    //Creat WcCategories 
    CREATE_WC_CATEGORIES(params) {
       
        return this.apollo.mutate({
            mutation: this.CREATE_WC_CATEGORY,
            variables: {
                "input": {
                    "wccategory": {
                        "category": params.category,
                    }
                    },
            },
        })
    }

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/wcCategories.ts